// docs: https://github.com/altostra/type-validations#readme
import { anyOf, arrayOf, is, objectOf, tupleOf } from "@altostra/type-validations";
import { number, string } from "@altostra/type-validations/lib/primitives";

import type { EngagementSurveyQuestionChartResult } from "./types";

const chartData = arrayOf(tupleOf(string, anyOf(string, number)));

const npsSegmentMetric = objectOf({
  count: number,
  percentage: number,
});

const engagementSurveyQuestionChartNpsResult = objectOf({
  question_id: string,
  question_type: is("nps"),
  total_responses: number,
  data: chartData,
  nps_score: objectOf({ score: number }),
  promoters: npsSegmentMetric,
  passives: npsSegmentMetric,
  detractors: npsSegmentMetric,
});

const engagementSurveyQuestionChartStandardResult = objectOf({
  question_id: string,
  question_type: string,
  total_responses: number,
  data: chartData,
});

export const isEngagementSurveyQuestionChartResult = (
  value: unknown
): value is EngagementSurveyQuestionChartResult => {
  if (typeof value !== "object" || value === null) {
    return false;
  }

  if ((value as { question_type?: unknown }).question_type === "nps") {
    return engagementSurveyQuestionChartNpsResult(value);
  }

  return engagementSurveyQuestionChartStandardResult(value);
};
